import React, { useEffect, useRef, useState } from "react";
import styles from "./comp_css/chapter_5.module.css";
import { Link } from "@mui/material";
import Head from "next/head";
import { useRouter } from "next/router";
import MembershipModal from "../../../components/Modal/MembershipModal";
import BlockData from "../../../central-doctraine-json/chapter5.json";
import Common_html from "./Common_html";

export default function Chapter_5() {
  // const corosalref = useRef()

  // useEffect(() => {
  //     if (corosalref.current) {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])


  const router = useRouter()
  const location = useRouter();
  const { pathname } = location;

  const [membershipOpen, setMembershipOpen] = useState(false);
  const memberfunc = () => {
    setMembershipOpen(true);
  };
  return (
    <>
      <Head>
        <title>Theistic School of Modern Day Theurgy | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Divine Infinite Being, Central Doctrine, Chapter-V"
        ></meta>
        <meta
          property="og:title"
          content="School of Our Divine Infinite Being- Theistic School of Modern Day Theurgy"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter5OG_image_Mithun_04-10-2023_v1_new.webp"
        ></meta>
        <meta property="og:image:alt" content="Illustration of a mystical altar surrounded by ancient symbols and modern elements, representing the Theistic School of Modern Day Theurgy. The altar radiates divine light, with a blend of traditional and contemporary spiritual practices, symbolizing the union of ancient wisdom with modern theurgy."></meta>
        <meta
          property="og:description"
          content="We are a Theistic school centrally in union with the Divine Infinite Being. Through Theurgy we reunite our higher selves seeded with direct knowledge of our immortal natures and the vision of a living Cosmos."
        ></meta>
        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=4"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter5OG_image_Mithun_04-10-2023_v1_new.webp"></meta>
        <meta property="twitter:image:alt" content="Illustration of a mystical altar surrounded by ancient symbols and modern elements, representing the Theistic School of Modern Day Theurgy. The altar radiates divine light, with a blend of traditional and contemporary spiritual practices, symbolizing the union of ancient wisdom with modern theurgy."></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=4"></meta>
        <meta name="twitter:title" content="Theistic School of Modern Day Theurgy | School of Our Divine Infinite Being"></meta>
        <meta name="twitter:description" content="We are a Theistic school centrally in union with the Divine Infinite Being. Through Theurgy we reunite our higher selves seeded with direct knowledge of our immortal natures and the vision of a living Cosmos."></meta>
         <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=5" />
      </Head>


           <Common_html BlockData={BlockData} />

      <MembershipModal membershipOpen={membershipOpen} setMembershipOpen={setMembershipOpen}/>
    </>
  );
}
